/** Ten digits that can exist under +1: area code and exchange both start 2-9. */
export function isNanpNumber(tenDigits: string): boolean {
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(tenDigits);
}

/** Display formatting for North American phone numbers: +1 (416) 989-6516.
 *  Anything that doesn't look like a 10/11-digit NA number passes through raw. */
export function formatPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (!isNanpNumber(ten)) return raw;
  return `+1 (${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}
